import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ZIPCODE_DATA_LOCAL_STORAGE_KEY } from '../constants/environment';

type ZipCodeStateType = {
  temporaryZipcode: string;
  confirmedZipcode: string;
};

const initialState: ZipCodeStateType = {
  temporaryZipcode: '',
  confirmedZipcode: '',
};

const zipCodeSlice = createSlice({
  name: 'zipCodeState',
  initialState,
  reducers: {
    setTemporaryZipCode: (state: ZipCodeStateType, action: PayloadAction<string>) => {
      return { ...state, temporaryZipcode: action.payload };
    },
    setConfirmedZipCode: (state: ZipCodeStateType, action: PayloadAction<string>) => {
      localStorage.setItem(ZIPCODE_DATA_LOCAL_STORAGE_KEY, action.payload);
      return { ...state, temporaryZipcode: action.payload, confirmedZipcode: action.payload };
    },
    removeZipCode: (state: ZipCodeStateType) => {
      return { ...state, temporaryZipcode: '', confirmedZipcode: '' };
    },
  },
});

export const selectZipCode = (state: any): ZipCodeStateType => state.zipCodeState;
export const { setTemporaryZipCode, setConfirmedZipCode, removeZipCode } = zipCodeSlice.actions;
export default zipCodeSlice.reducer;
